module.exports = __webpack_public_path__ + "img/1970East-036_WEB-min.83bc935b.jpg";